import { FunctionComponent, SVGProps, useMemo } from "react";
import { breakpoints } from "themes/breakpoints";
import Responsive from "ui/Responsive";
import MenuLargeDevices from "./MenuLargeDevices";
import MenuSmallDevices from "./MenuSmallDevices";
import { Icons } from "domain/public/Content/helper/icons";
import { MenuSection } from "interfaces/content";

type MenuData = {
  icon: FunctionComponent<SVGProps<SVGSVGElement>> | null;
  label: string;
  link: string;
};

export interface MenuDeviceProps {
  menus: Array<MenuData>;
}

interface MenuProps {
  data: MenuSection["data"];
}

const Menu = ({ data }: MenuProps) => {
  const menus = useMemo(() => {
    if (!data.items.length) return null;

    return data.items.map((item) => ({
      icon: Icons[item.icon],
      label: item.label,
      link: item.link,
    }));
  }, [data.items]);

  if (!menus) return null;

  return (
    <>
      <Responsive minWidth={breakpoints.md}>
        <MenuLargeDevices menus={menus} />
      </Responsive>
      <Responsive maxWidth={breakpoints.md}>
        <MenuSmallDevices menus={menus} />
      </Responsive>
    </>
  );
};

export default Menu;
